/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_Loss_ConnectorsInputs */



/**
* | output |
* | --- |
* | "External connectors (Google Drive, OneDrive, GitHub)" |
*
* @param {Plan_Tab_Downgrade_Loss_ConnectorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_loss_connectors = /** @type {((inputs?: Plan_Tab_Downgrade_Loss_ConnectorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_Loss_ConnectorsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Konnektoren (Google Drive, OneDrive, GitHub)")
	return /** @type {LocalizedString} */ ("External connectors (Google Drive, OneDrive, GitHub)")
});